"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeShippingPopover = void 0;
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const react_2 = require("@headlessui/react");
const react_popper_1 = require("react-popper");
const classnames_1 = __importDefault(require("classnames"));
function FreeShippingPopover(props) {
    const { placement, mainText, note, noteText, linkText, className } = props;
    const [referenceElement, setReferenceElement] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const [arrowElement, setArrowElement] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        placement: placement,
        strategy: 'absolute',
        modifiers: [
            { name: 'arrow', options: { element: arrowElement, padding: 10 } },
            {
                name: 'offset',
                options: {
                    offset: [6, 6],
                },
            },
        ],
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Popover, { as: "span", className: (0, classnames_1.default)('relative inline-block relative top-0.5', className) }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Popover.Button, { ref: (e) => setReferenceElement(e), className: "text-blue hover:text-blue-hover transition-colors relative underline hover:no-underline focus:no-underline font-semibold" },
                react_1.default.createElement(fa_1.FaQuestionCircle, { "aria-label": "Need more information?" })),
            react_1.default.createElement(react_2.Transition, { show: open, as: "span", enter: "transition duration-200 ease-out w-full z-100", enterFrom: "transform opacity-0 z-100", enterTo: "transform opacity-100 z-100", leave: "transition duration-200 ease-out w-full z-100", leaveFrom: "transform opacity-100 z-100", leaveTo: "transform opacity-0 z-100", className: "z-100", static: true },
                react_1.default.createElement(react_2.Popover.Panel, Object.assign({ static: true, className: "popper-panel z-100", ref: (e) => setPopperElement(e), style: styles.popper }, attributes.popper),
                    react_1.default.createElement("div", { className: "popper-arrow", ref: (e) => setArrowElement(e), style: styles.arrow }),
                    react_1.default.createElement("div", { className: "block bg-white shadow-md-all rounded-lg text-sm p-4 py-2 w-48 sm:w-64 text-gray border border-[#f4f4f4]" },
                        react_1.default.createElement("p", { className: "mb-4" }, mainText),
                        react_1.default.createElement("p", { className: "mb-4" },
                            react_1.default.createElement("strong", null, note),
                            " ",
                            noteText),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("a", { href: "/en/about/shipping-information#free-shipping", className: "link" }, linkText))))))))));
}
exports.FreeShippingPopover = FreeShippingPopover;
